import { selectors } from 'data'
import { InstrumentType } from 'data/types'
import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { getBaseCurrency, getCounterCurrency } from 'utils/pairs'

import Money from './Money'

export enum CurrencySide {
  BASE,
  COUNTER
}

type GetDecimalsProps = {
  currencySide?: CurrencySide
  instrument?: InstrumentType
}
const getDecimals = ({ currencySide, instrument }: GetDecimalsProps) => {
  if (!instrument) return 2
  return currencySide === CurrencySide.COUNTER
    ? instrument.price_increment
    : instrument.volume_increment
}

type OwnProps = {
  amount: number | string
  currencySide?: CurrencySide
  hideCurrency?: boolean
  pair: string
}
type Props = ConnectedProps<typeof connector> & OwnProps

// PairMoney is used to render money linked to a currency exchange. It considers
// the pair and if it's in base or counter currency. For rendering money unlinked
// to a currency exchange use Money
const SimplePairMoney = ({ amount, currencySide, hideCurrency, instrument, pair }: Props) => {
  const decimals = getDecimals({ currencySide, instrument })
  const currency =
    currencySide === CurrencySide.COUNTER ? getCounterCurrency(pair) : getBaseCurrency(pair)
  return (
    <Money
      amount={amount}
      currency={currency}
      fixedDecimals={decimals}
      hideCurrency={hideCurrency}
    />
  )
}

SimplePairMoney.Currency = CurrencySide

const mapStateToProps = (state, { pair }: OwnProps) => ({
  instrument: selectors.instrument.getInstrumentsIndexed(state)[pair]
})
const connector = connect(mapStateToProps)
const PairMoney = connector(SimplePairMoney)
export default PairMoney

type BaseMoney = Omit<OwnProps, 'currencySide'>

// Simple wrapper over PairMoney for base currency.
// Usage: <BaseMoney amount='45.6' pair='BTC-USD' /> will print BTC 45.6
export const BaseMoney = (props: BaseMoney) => (
  <PairMoney currencySide={CurrencySide.BASE} {...props} />
)

// Simple wrapper over PairMoney for base currency.
// Usage: <CounterMoney amount='45.6' pair='BTC-USD' /> will print $45.6
export const CounterMoney = (props: BaseMoney) => (
  <PairMoney currencySide={CurrencySide.COUNTER} {...props} />
)
